import { render, staticRenderFns } from "./MyNews.vue?vue&type=template&id=36b76c2e&scoped=true"
import script from "./MyNews.vue?vue&type=script&lang=js"
export * from "./MyNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b76c2e",
  null
  
)

export default component.exports